import {UI} from "../../../stem-core/src/ui/UIBase";

import {AuthorizeApplicationPageClass} from "../../website/authenticated/pages/authorize-application/AuthorizeApplicationPage";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {OAuthError} from "../../../client/connection/services/BlinkOAuthService";
import {BlinkPayLogoText} from "../../SVGElements";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {BasePanelPage, BasePanelPageStyle} from "./panels/BasePanelPage";


class PaywallAuthorizeApplicationPage extends AuthorizeApplicationPageClass {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            clientId: iFrameMerchantService.merchantId,
        };
    }

    onAuthorizationReject() {
        iFrameConnection.sendToSDK(IFrameMessages.BLINK_OAUTH_AUTHORIZE_RESPONSE,
            {error: OAuthError.getErrorObjectByCode(OAuthError.errorCodes.ACCESS_AUTHORIZATION_REJECTED)});
    }

    handleAuthorizationRequestSuccess(response) {
        iFrameConnection.sendToSDK(IFrameMessages.BLINK_OAUTH_AUTHORIZE_RESPONSE, {response});
    }

    handleErrorResponse(error = {}) {
        super.handleErrorResponse(error);
        iFrameConnection.sendToSDK(IFrameMessages.BLINK_OAUTH_AUTHORIZE_RESPONSE, {error});
    }
}

class AuthorizationPanelStyle extends BasePanelPageStyle {
    @styleRule
    logo = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 24,
    };

    @styleRule
    authorizationApplication = {
        position: "relative",
        minHeight: "initial !important",
    }
}

// TODO: Probably inherit BasePanel?
@registerStyle(AuthorizationPanelStyle)
export class AuthorizationPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;

        return [
            <BlinkPayLogoText size={18} backgroundColor={this.styleSheet.themeProps.WALLET_12}
                              className={styleSheet.logo} />,
            <PaywallAuthorizeApplicationPage ref="authorizeApplicationPage"
                                             className={styleSheet.authorizationApplication}/>
        ];
    }
}
